const getResizedImageUrl = (url, dimension, size) => {
  if (
    !url
    || /^(data:|blob:)/i.test(url)
    || !['w', 'h'].includes(dimension)
    || !Number.isInteger(size)
    || size <= 0
  ) {
    return url || '';
  }

  const [urlWithoutHash, hash] = url.split(/#(.*)/s);
  const separator = urlWithoutHash.includes('?') ? '&' : '?';
  const resizedUrl = `${urlWithoutHash}${separator}${dimension}=${size}`;

  return hash === undefined ? resizedUrl : `${resizedUrl}#${hash}`;
};

export default getResizedImageUrl;
